export const TAB_CAMPAIGNS = {
  key: 'campaign',
  title: 'Campaigns',
};

export const TAB_CREATIVES = {
  key: 'creative',
  title: 'Creatives',
};
